module.exports = __webpack_public_path__ + "media/images/icons/brands/figma-e59a8ddcd720229093e61ccc0895f0f2.svg";